module.exports = __webpack_public_path__ + "static/media/icon_restoration_pontic_4.25a03d40.svg";